// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2508":"fcf709e1890ff4fc4a91","4827":"6fec498c395da02833b0"}[chunkId] + ".css";
};